<template>
  <base-view-table
    title="Produtos Sugeridos"
    :loading="loading"
    :table="table"
    :use-table="false"
    :countProducts="countProducts"
    @search="list()"
  >
    <template #table>
      <b-table
        hover
        show-empty
        empty-text="Sem registros encontrados"
        :fields="table.headers"
        :items="table.records"
      >
        <template #cell(produtos)="data">
          <span>{{ data.item.produtos }}</span>
        </template>
        <template #cell(actions)="data">
          <b-btn
            variant="danger"
            class="mr-2"
            v-if="hasWritePermission()"
            @click="deleteProduct(data.item.id)"
            size="sm"
            :title="'Excluir produto'"
          >
            <i class="fas fa-trash-alt"></i>
          </b-btn>

          <b-btn
              @click="
                $refs.shopkeeperDetails.toggleOpen({
                  shopkeeperId: data.item.userId,
                })
              "
              variant="warning"
              title="Ver Dados do Lojista"
              size="sm"
            >
              <i class="fas fa-eye"></i>
          </b-btn>
        </template>
      </b-table>
    </template>
        <ShopkeeperDetails ref="shopkeeperDetails" />
  </base-view-table>
</template>

<script>
import { mapState } from 'vuex';
import makeToast from 'Mixins/makeToast';
import BaseViewTable from 'Components/View/BaseViewTable.vue';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import SelectShopkeeperWithApp from 'Components/Inputs/SelectShopkeeperWithApp.vue';
import ShopkeeperDetails from 'Components/Shopkeeper/ShopkeeperDetails.vue';
import ContactShopkeeper from '@/views/administrador/shopkeeper-app/produtosSugeridos/ContactShopkeeper.vue';

export default {
  name: 'ListSuggestProduct',
  mixins: [makeToast],
  components: {
    BaseViewTable,
    PeriodsFilters,
    SelectShopkeeperWithApp,
    ShopkeeperDetails,
    ContactShopkeeper
  },
  data() {
    return {
      loading: false,
      countProducts: 0,
      fields: {
        shopkeepersIds: [],
        startDate: '',
        endDate: '',
        id: null,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'produtos',
            label: 'Nome do produto',
            sortable: true,
          },
          {
            key: 'codigo_barra',
            label: 'Código de barras',
            sortable: true,
          },
          {
            key: 'marca_produtos',
            label: 'Marca',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
      shopkeepers: [],
      timer: null,
    };
  },

computed: {
  ...mapState(['token', 'dadosUsuario']),
},

  mounted() {
    this.list();
  },
  methods: {
    list() {
      this.loading = true;
      this.$store
        .dispatch('gettingAllSuggestProducts')
        .then((resp) => {
            this.table.records = resp.data;
            this.countProducts = resp.data.length;
        })
        .catch(() => {
            this.$store.dispatch('endLoader');
          this.makeToast('Aviso!', 'Erro ao listar produtos sugeridos!', 'warning')
        })
    },

    deleteProduct(prodID) {
      this.$store
        .dispatch('deleteProduct', prodID)
        .then(() => {
          this.makeToast(
            'Sucesso!',
            'Produto deletado com sucesso!'
    );
      setTimeout(() => {
        this.list();
      }, 1000);
        })
        .catch(() => {
            this.$store.dispatch('endLoader');
          this.makeToast(
            'Erro excluir produto!',
            'warning'
    );
    this.loading = false;
        })
    },

    hasWritePermission() {
        return this.dadosUsuario.permitido_escrita == 1;
    },
  },
};
</script>

<style scoped>
.limit-chars {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 99%;
}
</style>